export default __webpack_public_path__ + "static/media/slate-originals.1362af1f.svg";